import { footerStyles } from "@insite/content-library/Pages/Footer";
import baseTheme from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        > div {
            background-color: ${getColor("primary")};
            display: flex;
            justify-content: space-between;

            a > span {
                color: #FFFFFF!important;

                &:hover {
                    color: #F7661F!important;
                }
            }
          
        }      
    `,
};
